/// <reference path="../types.d.ts" />

import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import * as dictionary from '../actions/dictionary';
import { syncActions } from '../actions/dictionary';
import { LOAD_STATES } from './common';

import { jumpContext } from '../actions/contexts.action';
import { logout } from '../actions/ui';
import * as dictionaryValueActions from '../actions/dictionary-values';
import * as dictionaryRequest from '../actions/dictionary-request.actions';

const reducer = createReducer(InitialState.dictionary, builder => {
  // Default cases from cmxReducerFactory: reset state on logout or context jump
  builder.addCase(logout.type, () => ({ ...InitialState.dictionary }));
  builder.addCase(jumpContext.pending.type, () => ({
    ...InitialState.dictionary
  }));

  builder.addCase(dictionary.listItems.pending, state => {
    return {
      ...state,
      items: [],
      loadState: LOAD_STATES.initial
    };
  });
  builder.addCase(dictionary.listItems.rejected, state => {
    return { ...state, loadState: LOAD_STATES.failed };
  });
  builder.addCase(dictionary.listItems.fulfilled, (state, action) => {
    const result = action.payload;
    const { content } = result;

    const { sortablePageable } = state;
    const sp = { ...sortablePageable, pageableDefinition: result };

    return {
      ...state,
      loadState: LOAD_STATES.done,
      items: content,
      sortablePageable: sp
    };
  });

  builder.addCase(syncActions.chooseOrg, (state, action) => {
    return { ...state, selectedOrg: action.payload };
  });
  builder.addCase(syncActions.chooseDictionary, (state, action) => {
    return { ...state, selectedDictionaryId: action.payload };
  });

  builder.addCase(dictionaryRequest.fetchRequestStatus.fulfilled, (state, action) => {
    const requestResponse = action.payload;
    return {
      ...state,
      selectedDictionaryId: requestResponse.dictionaryId ?? undefined
    };
  });

  builder.addCase(dictionary.loadDictionaries.pending, state => {
    return {
      ...state,
      sortablePageable: { ...InitialState.dictionary.sortablePageable },
      items: [],
      loadState: LOAD_STATES.initial
    };
  });
  builder.addCase(dictionary.loadDictionaries.rejected, state => {
    return { ...state, loadState: LOAD_STATES.failed };
  });
  builder.addCase(dictionary.loadDictionaries.fulfilled, (state, action) => {
    let item: any = action.meta.arg;
    const path = [
      {
        displayName: item.tenantName,
        display: true,
        link: false,
        data: `/cmx/admin/orgs/${item.id}/dictionary/${item.organizationCode}/`
      }
    ];

    return { ...state, path, selectedOrg: action.meta.arg };
  });

  builder.addCase(dictionary.loadDictionary.pending, state => {
    return { ...state, items: [], loadState: LOAD_STATES.started };
  });
  builder.addCase(dictionary.loadDictionary.rejected, state => {
    return { ...state, loadState: LOAD_STATES.failed };
  });
  builder.addCase(dictionary.loadDictionary.fulfilled, (state, action) => {
    return { ...state, loadState: LOAD_STATES.done };
  });

  builder.addCase(dictionaryRequest.uploadDictionary.pending, state => {
    return {
      ...state,
      loadState: LOAD_STATES.started
    };
  });

  builder.addCase(dictionaryValueActions.listAssociatedDictionaries.fulfilled, (state, action) => {
    const associatedDictionaries = action.payload;
    return {
      ...state,
      associatedDictionaries
    };
  });

  builder.addCase(syncActions.saveAssociatedDictionaries, (state, action) => {
    return {
      ...state,
      associatedDictionaries: action.payload
    };
  });
});

export default reducer;
